﻿import LfDataService from '../../../Services/LfDataService';

import {
    pageHasErroredAction,
    pageErrorAction
} from '../../../State/actions';

export const FETCH_FAQ_QUESTIONS_STARTED = 'FETCH_FAQ_QUESTIONS_STARTED';
export const FETCH_FAQ_QUESTIONS_COMPLETED = 'FETCH_FAQ_QUESTIONS_COMPLETED';

export const fetchFAQQuestionsStarted = () => ({
    type: FETCH_FAQ_QUESTIONS_STARTED
});

export const fetchFAQQuestionsCompleted = (data) => ({
    type: FETCH_FAQ_QUESTIONS_COMPLETED,
    payload: data
});

export const fetchCategorizedFAQData = (selectedCategory) => {

    const lfDataService = new LfDataService();

    return async (dispatch) => {
        dispatch(fetchFAQQuestionsStarted());

        try {
            const response = await lfDataService.getCategorizedFAQData(selectedCategory);
            const { categories, fAQQuestions } = response;

            dispatch(fetchFAQQuestionsCompleted({ categories, fAQQuestions }));
        } catch (error) {
            dispatch(pageErrorAction(error));
            dispatch(pageHasErroredAction(true));
        }
    };
}